import { lazy } from 'react';

const Project = lazy(() => import('../../views/Project/index'));
const ProjectTab = lazy(() => import('../../views/Project/ProjectTabIndex'));
const ProjectForm = lazy(() => import('../../views/Project/component/Form'));
const ProjectTeams = lazy(() => import('../../views/Project/component/ProjectTeams/ProjectTeams'));
const Road = lazy(() => import('../../views/Project/component/road/components/Road'));
const MixDesign = lazy(() => import('../../views/Project/component/MixDesign/index'));
const AddTCSForm = lazy(() => import('../../views/Project/component/Tcs/components/Form'));
const ScheduleBForm = lazy(() => import('../../views/Project/Profile/Tab/ScheduleAnnex2/component/AnnexOne/components/Form'));
const ScheduleBReporting = lazy(() => import('../../views/Project/Profile/Tab/ScheduleAnnex2/component/AnnexOne/components/SchBReporting'));
const ScheduleBReportingEditForm = lazy(() =>
    import('../../views/Project/Profile/Tab/ScheduleAnnex2/component/AnnexOne/components/SchBReportingEditForm')
);

const ProjectProfile = lazy(() => import('../../views/Project/Profile/index'));
const ScheduleBReport = lazy(() => import('../../views/Project/Profile/ScheduleBReport/index'));

const Tcs = lazy(() => import('../../views/Project/component/Tcs/index'));
const ScheduleGReporting = lazy(() => import('../../views/Project/Profile/Tab/ScheduleAnnex3/component/Road/components/RoadItemReporting'));
const RoadMaterialReport = lazy(() => import('../../views/Project/Profile/Tab/components/RoadMaterialReport'));

const ProjectRoutes = [
    // {
    //     path: '/project',
    //     element: <Project />
    // },
    {
        path: '/project',
        element: <ProjectTab />
    },
    {
        path: '/project/add',
        element: <ProjectForm />
    },
    {
        path: '/project/edit/:id',
        element: <ProjectForm />
    },
    {
        path: '/project/project-teams/:id',
        element: <ProjectTeams />
    },
    {
        path: '/project/road/:id',
        element: <Road />
    },
    {
        path: '/project/mix-design/:id',
        element: <MixDesign />
    },
    {
        path: '/project/profile/:id',
        element: <ProjectProfile />
    },
    {
        path: '/project/profile/road-material-report/:id',
        element: <RoadMaterialReport />
    },
    {
        path: '/project/profile/scheduleB-report/:name/:id',
        element: <ScheduleBReport />
    },
    {
        path: '/project/tcs/:id',
        element: <Tcs />
    },
    {
        path: '/project/tcs/:projectId/:projectName/add',
        element: <AddTCSForm />
    },
    {
        path: '/project/tcs/:projectId/:projectName/edit/:id',
        element: <AddTCSForm />
    },
    {
        path: '/project/tcs/:projectId/:projectName/view/:id',
        element: <AddTCSForm />
    },
    {
        path: '/project/schedule-b/reporting/add/:id',
        element: <ScheduleBForm />
    },
    {
        path: '/project/schedule-b/reporting/edit/:id',
        element: <ScheduleBReportingEditForm />
    },
    {
        path: '/project/schedule-b/reporting/:id',
        element: <ScheduleBReporting />
    },
    {
        path: '/project/profile/scheduleG-report/:id',
        element: <ScheduleGReporting />
    }
];

export default ProjectRoutes;
